import { render, staticRenderFns } from "./SolePropF.vue?vue&type=template&id=3dfc15db"
import script from "./SolePropF.vue?vue&type=script&lang=js"
export * from "./SolePropF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports